import { request } from './index';
import axios from '@/axios';
 
export async function getBloodList(item) {
 
    let routeName; 
    routeName = 'donor/blood_group_list'; 

    try {
        const { data } = await axios.get(routeName, {
            params: {
                name: item.name ?? '',
                factor: item.factor ?? '',
                kind_of_donor: item.kind_of_donor ?? '',
                unity: item.unity ?? ''
            }
        });

        return data.data;
    } catch (error) {
        return error;
    }
}

export async function getSerologyList(item, profile, router_path) { 
    const currentPath = router_path == '/sorologia-nat';
    const routeName = profile == 'tec_hemoba_nat' || currentPath
    ? 'donor/nat_list' 
    : 'donor/serology_list'; 

    try {
        const { data } = await axios.get(routeName, {
            params: {
                name: item.name ?? '',
                factor: item.factor ?? '',
                kind_of_donor: item.kind_of_donor ?? '',
                unity: item.unity ?? ''
            }
        });

        return data.data;
    } catch (error) {
        return error;
    }
}

export async function getUnities() {
    return await request("GET", "/unities")
}

export async function getPatienteSituations() {
    return await request("GET", "/kind_of_donors")
}
export async function getFactors() {
    return await request("GET", "/blood_factors")
}
export async function getPatientsNotBloodGroups() {
    return await request("GET", "/donor/no_blood_group")
} 
export async function getSerolgyStatus(type_serology_status_id) {  
    try {
        const { data } = await axios.get(`/serology_status/list`, 
        {
            params: {
                type_serology_status_id: type_serology_status_id
            }
        });

        return data.data ?? data;
    } catch (error) {
        return error;
    }
}
export async function getSerolgyExams() {  
    try {
        const { data } = await axios.get(`/serology_tests/list`, 
        {
            params: {
                type_serology_status_id: ''
            }
        });

        return data.data ?? data;
    } catch (error) {
        return error;
    }
}
export async function getSerologyDonors(path) {  
    try {
        const { data } = await axios.get(`/donor/${path}`); 
        return data.data ?? data;
    } catch (error) {
        return error;
    }
}